import fs from 'fs-extra';
import path from 'path';
import chalk from 'chalk';
import validateNpmPackageName from 'validate-npm-package-name';

/**
 * 验证项目名称是否有效
 * @param name 项目名称
 * @returns 有效返回true，无效返回错误信息
 */
export function validateProjectName(name: string): boolean | string {
  // 检查项目名是否为空
  if (!name || name.trim() === '') {
    return '项目名称不能为空';
  }

  // 验证是否符合npm包命名规范
  const { validForNewPackages, errors, warnings } = validateNpmPackageName(name);

  if (!validForNewPackages) {
    const errorMessages = [
      ...(errors || []),
      ...(warnings || [])
    ];
    return `无效的项目名称: ${errorMessages.join(', ')}`;
  }

  return true;
}

/**
 * 检查目录是否存在，并处理冲突
 * @param targetDir 目标目录
 * @param projectName 项目名
 * @param force 是否强制覆盖
 * @returns 最终的项目路径或null（如果操作被取消）
 */
export async function checkDirectoryExists(
  targetDir: string,
  projectName: string,
  force: boolean
): Promise<string | null> {
  // 完整的项目路径
  const projectPath = path.join(targetDir, projectName);

  // 检查目录是否已存在
  if (fs.existsSync(projectPath)) {
    if (force) {
      console.log(chalk.yellow(`目标目录 ${projectPath} 已存在，将被强制覆盖`));
      await fs.remove(projectPath);
      return projectPath;
    } else {
      console.error(chalk.red(`目标目录 ${projectPath} 已存在，如需覆盖请使用 --force 选项`));
      return null;
    }
  }

  return projectPath;
}
